import { MyAccessibleDoctor } from "../../utils/bridges/types/doctorProfile";

export const doctorNameWithSpecilisation = (doctor: MyAccessibleDoctor) => {
  const doctorFullName = `${doctor?.personal?.s || "Dr."} ${[
    doctor?.personal?.name?.f,
    doctor?.personal?.name?.l,
  ]
    .filter(Boolean)
    .join(" ")}`;
  const doctorSpecilisation = doctor?.professional?.major_speciality?.name;
  if (!doctor) return "";
  if (!doctorSpecilisation) return doctorFullName;
  return `${doctorFullName} (${doctorSpecilisation})`;
};
